import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface Screen {
  number: string;
  label: string;
  image: string;
}

@Component({
  selector: 'app-sales-mobile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sales-mobile.html',
  styleUrls: ['./sales-mobile.css'],
})
export class SalesMobileComponent {
  readonly screens: Screen[] = [
    { number: '01', label: 'Active Sale', image: 'images/screens/pos-screens/pos-active-transaction.png' },
    { number: '02', label: 'Payment Screen', image: 'images/screens/pos-screens/pos-payment-processing.png' },
    { number: '03', label: 'Touch Layout', image: 'images/screens/pos-screens/pos-retail-cafeteria-layout.webp' },
    { number: '04', label: 'Empty Cart', image: 'images/screens/pos-screens/pos-empty-sale-state.png' },
    { number: '05', label: 'Product View', image: 'images/screens/pos-screens/pos-visual-product-grid.png' },
  ];

  activeIndex = 0;

  select(index: number): void {
    this.activeIndex = index;
  }
}
